import { Flex } from "@chakra-ui/react"
import { ProjectCard } from "./card"
import { ProjectList } from "./project-list"

export const ProjectsComponent = () => {
  const renderProjects = () => {
    return ProjectList.map((project) => <ProjectCard {...project} />)
  }

  return (
    <Flex direction={"row"} flexWrap="wrap" justifyContent="space-around" p={8}>
      {renderProjects()}
    </Flex>
  )
}
